/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import MuiListItem from "@material-ui/core/ListItem";
import { withStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import { startsWith } from "lodash";
import { List, ListItemIcon, ListItemText, ListItemButton } from "@mui/material";

const DrawerListItem = (props) => {
    
    const theme = useTheme();
    const activePath = props?.activePath;
    const handleListItemClick = props?.handleListItemClick;
    const open = props?.open;
    const item = props?.item;
    
    const path = item?.path;
    const children = item?.children;
    const name = item?.name;
    const icon = item?.icon;
    
    const matchesPath = (navItemPath, activePath) => {
        let matches = false;
        matches = navItemPath && activePath && startsWith(activePath, navItemPath);
        if (matches) {
            // Logger.debug(`matchesPath: ${activePath} ${navItemPath}`)
        }
        return matches;
    };

    const selected = matchesPath(path, activePath);
    
    const ListItemWrapper = withStyles({
        root: {
            backgroundColor: "white",
            fontSize: "0.875rem !important",
            color: "#7a7a7a",
            "& .MuiListItemIcon-root": {
                color: "#7a7a7a",
            },
            "&$selected": {
                backgroundColor: theme.palette.secondary.background,
                color: theme.palette.secondary.main,
                "& .MuiListItemIcon-root": {
                    color: theme.palette.primary.main,
                    fontWeight: "bold",
                },
                "& .MuiListItemText-root": {
                    color: "black",
                },
                "& .MuiTypography-root": {
                    fontWeight: "700 !important",
                },
            },
            "&$selected:hover": {
                backgroundColor: theme.palette.secondary.background,
                color: theme.palette.secondary.main,
                "& .MuiButtonBase-root": {
                    backgroundColor: theme.palette.secondary.background,
                },
                "& .MuiListItemIcon-root": {
                    color: theme.palette.secondary.main,
                },
            },
            "&:hover": {
                backgroundColor: "white",
                color: theme.palette.secondary.main,
                "& .MuiButtonBase-root": {
                    backgroundColor: "white",
                },
                "& .MuiListItemIcon-root": {
                    color: theme.palette.secondary.main,
                },
            },
        },
        selected: {},
    })(MuiListItem);
    
    return (
        <>
            <ListItemWrapper
                style={{
                    // border: '1px solid red',
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start"
                }}
                selected={selected}
            >
                {/*<ListItem>*/}
                <ListItemButton
                    sx={{
                        minHeight: 36,
                        // justifyContent: open ? 'initial' : 'center',
                        px: 1,
                    }}
                    onClick={(event) => handleListItemClick(event, path)}
                >
                    <ListItemIcon
                        sx={{
                            minWidth: 0,
                            mr: open ? 2 : "auto",
                            justifyContent: "center",
                        }}
                    >
                        {icon}
                    </ListItemIcon>
                    <ListItemText
                        primary={name}
                        className={"side-nav-text"}
                        sx={{ opacity: open ? 1 : 0, textTransform: "capitalize" }}
                    />
                </ListItemButton>
            </ListItemWrapper>
                
            {children &&
                    <List component='nav'>
                        {children.map((child, index) => {
                            const selectedChild = matchesPath(child.path, activePath);
                            return (
                                <ListItemWrapper
                                    key={index}
                                    style={{
                                        // border: '1px solid lime',
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                    }}
                                    selected={selectedChild}
                                >
                                    {/*<ListItem>*/}
                                    <ListItemButton
                                        sx={{
                                            minHeight: 36,
                                            // justifyContent: open ? 'initial' : 'center',
                                            px: 1,
                                        }}
                                        onClick={(event) => handleListItemClick(event, child.path)}
                                    >
                                        <ListItemIcon
                                            sx={{
                                                // border: '1px solid red',
                                                justifyContent: "center",
                                                minWidth: 0,
                                                width: 24,
                                                ml: open ? 2 : 0,
                                                mr: open ? 2 : "auto",
                                            }}
                                        >
                                            {child.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={child.name}
                                            className={"side-nav-text"}
                                            sx={{ opacity: open ? 1 : 0, textTransform: "capitalize" }}
                                        />
                                    </ListItemButton>
                                    {/*</ListItem>*/}
                                </ListItemWrapper>
                            );
                        })}
                    </List>
            }
        </>
    );
};
export { DrawerListItem };
